export type Course = {
  id: string
  name: string
  hours: number
  sciencepoints: number
  mathSciencepoints: string | boolean
  languagepoints: number
  included: boolean
  is235course: boolean
  grade: number
  numExams: 0 | 1 | 2
  exam: number
  exam2: number
  improved: number
  improved2: number
  hadExam?: boolean
  timestampAdded?: number
  hasTwoExams: boolean
}

export interface UserDetails {
  name: string
  email: string
  phone: string
  message: string
  birthyear: number
  studyStartYear: number
}

export const nullUserDetails: UserDetails = {
  name: '',
  email: '',
  phone: '',
  message: '',
  birthyear: new Date().getFullYear() - 19,
  studyStartYear: new Date().getFullYear(),
}

export interface ExtraPoints {
  'Militær/siviltjeneste': boolean
  Folkehøgskole: boolean
  '60 studiepoeng': boolean
  '30 studiepoeng': boolean
}

export const nullExtraPoints: ExtraPoints = {
  'Militær/siviltjeneste': false,
  Folkehøgskole: false,
  '60 studiepoeng': false,
  '30 studiepoeng': false,
}

export interface CalculatedDiploma {
  diploma: string
  improved: boolean
  age: number
  numCourses: number
  grades: number
  average: number
  grades_improved: number
  science: number
  language: number
  totalScienceAndLanguage: number
  age_normal: number
  age_235: number
  extra: number
  total_first: number
  total_normal: number
  total_improved: number
  total_235: number
}
